import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"

import { TeamPerson } from "~/api/types/TeamPerson"
import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { LinksBundle } from "~/components/LinksBundle/LinksBundle"

import { Raw } from "../raw"
import styles from "./index.module.css"

type Props = TeamPerson & {
  className?: string
  inCommittee?: boolean
}

export const TeamCard: React.FC<Props> = ({
  inCommittee,
  className,
  code,
  previewPicture,
  name,
  position,
  assets,
  file,
  funds,
}) => {
  const { t } = useTranslation()

  return (
    <Card className={cn(className, styles.Wrapper)} link={`/about/team/${code}`}>
      <div className={styles.Photo}>
        <img src={previewPicture} />
      </div>

      <div className={styles.Info}>
        <Heading className={styles.Name} like="h4">
          <Raw html={name} />
        </Heading>

        {position && !inCommittee && (
          <div className={styles.Job} dangerouslySetInnerHTML={{ __html: position }} />
        )}

        {file.link !== null && (
          <a
            className={styles.Download}
            dangerouslySetInnerHTML={{
              __html: `${t("TeamCard.file.title")} (${file.format}, ${file.sizeValue})`,
            }}
            href={file.link}
          />
        )}

        {assets && (
          <div className={styles.Links}>
            <LinksBundle className={styles.LinksBundle}>
              {assets.map(({ code, name }) => (
                <Link key={code} href={`/assets/${code}`} view="arrow">
                  <Raw html={name} />
                </Link>
              ))}
            </LinksBundle>
          </div>
        )}

        {funds && (
          <div className={styles.Links}>
            <LinksBundle className={styles.LinksBundle}>
              {funds.map(({ code, name }) => (
                <Link key={code} href={`/funds/${code}`} view="arrow">
                  <Raw html={name} />
                </Link>
              ))}
            </LinksBundle>
          </div>
        )}
      </div>
    </Card>
  )
}
